<template lang="pug">
  h1.logo
    a(href="//mtonline.latercera.com")
      img(src="assets/images/logos/mtonline.svg", alt="MT Online")

</template>

<script>
  export default  {
    name: 'logo'
}
</script>

<style scoped lang="postcss">
  .logo {
    min-width: 120px;
    margin: 0;
  }
</style>
